export default "__VITE_ASSET__CHCXGN8m__"